const ZipInputField = ({ name,type,inputRef,tabIndex,maxLength,autoComplete,autoFocus,onPaste,onKeyUp, onKeyDown}) => {
	return (
		<input
			name={name}
			id={name}
			type={type}
			autoComplete={autoComplete}
			className="zipInput"
			ref={inputRef}
			tabIndex={tabIndex}
			maxLength={maxLength}
			onKeyUp={onKeyUp}
			placeholder="x"
			onPaste={onPaste}
			autoFocus = {autoFocus}
			onKeyDown={onKeyDown}
		/>
	);
};

export default ZipInputField;
